import { Check, Close } from '@mui/icons-material';
import { Chip } from '@mui/material';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-premium';
import { CustomGridColDef, createColumns } from 'components/enhanced/data-grid/utils';
import { useTranslation } from 'react-i18next';
import { IMedicalService } from './types';

export function MedicalServicesColumns(translationPrefix, etlHeaderNames, isAdmin): GridColDef[] {
  const { t } = useTranslation();

  const columnsConfig: CustomGridColDef<IMedicalService>[] = [
    {
      field: 'exam'
    },
    {
      field: 'registered',
      headerName: t(`global.registered`),
      maxWidth: 80,
      sortable: true,
      renderCell: (params: GridRenderCellParams) => (
        <Chip
          sx={{ background: 'transparent' }}
          icon={params.value ? <Check color="success" /> : <Close color="error" />}
        />
      )
    },
    {
      field: 'quantity',
      maxWidth: 80
    },
    {
      field: 'request_date'
    },
    {
      field: 'service_date'
    },
    {
      field: 'req_department',
      editable: isAdmin
    },
    {
      field: 'req_laboratory'
    },
    {
      field: 'exec_laboratory'
    },
    {
      field: 'workstation',
      headerName: t(`global.workstation`)
    }
  ];

  return createColumns<IMedicalService>(columnsConfig, t, `${translationPrefix}.entity`);
}
